import{useMemo as r}from"react";const o=o=>r((()=>{if("function"==typeof o)return o();throw new Error("Updater should be callable")}),[]);export{o as useConst};
